<footer class="footer">
  <pichincha-typography
    variant="prelo"
    weight="500"
    size="14px"
    line-height="20px"
    color="bp-grayScale500"
  >
    © {{ getDate() }} Banco Pichincha C.A.
  </pichincha-typography>
  <pichincha-typography
    variant="prelo"
    weight="500"
    size="14px"
    line-height="20px"
    color="bp-grayScale500"
    >&nbsp;Todos los derechos reservados.</pichincha-typography
  >
</footer>
